import React from 'react'
import { I18n } from 'react-i18next'
import A from '../../components/A'

const VCCustomLatestOffers = ({href, t}) => (
  <I18n>
    {
      t => (
        <div className='latestOffers'><h2>{t('custom:latestOffers')}</h2><A href={href}>{t('custom:check')}</A></div>
      )
    }
  </I18n>
)

export default VCCustomLatestOffers


// WEBPACK FOOTER //
// ./src/custom/components/VCCustomLatestOffers.js